import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const SAVE_ACCOUNT_COMMENTS_REQUEST = 'SAVE_ACCOUNT_COMMENTS_REQUEST';
export const SAVE_ACCOUNT_COMMENTS_SUCCESS = 'SAVE_ACCOUNT_COMMENTS_SUCCESS';
export const SAVE_ACCOUNT_COMMENTS_FAILURE = 'SAVE_ACCOUNT_COMMENTS_FAILURE';

function request() {
  return {
    type: SAVE_ACCOUNT_COMMENTS_REQUEST,
    isSavingAccount: true,
  };
}

function receive(savedComment) {
  return {
    type: SAVE_ACCOUNT_COMMENTS_SUCCESS,
    isSavingAccount: false,
    savedComment,
    accountError: null
  };
}

function reject(accountError) {
  return {
    type: SAVE_ACCOUNT_COMMENTS_FAILURE,
    isSavingAccount: false,
    accountError
  };
}

export function saveAccountComments(accountId, newComment) {
  const formData = new FormData();
  formData.append('newComment', newComment);

  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .saveAccountComments(accountId, formData)
      .then((response) => {
        dispatch(receive(response.data));
        toastr.success('Success', 'Comments saved successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
